import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { navIcons } from '../iconMap';

function EmptyPage({ page, t }) {
  return (
    <motion.div className="page-content empty-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <div className="page-title">
        <span className="eyebrow">GFI INTERNATIONAL</span>
        <h1>{t[page]}</h1>
        <p>{t.pageDescriptions[page]}</p>
      </div>
      <section className="empty-card">
        <span><SafeIcon icon={navIcons[page] || FiIcons.FiFolder} /></span>
        <h2>{t.emptyTitle}</h2>
        <p>{t.emptyMessage}</p>
      </section>
    </motion.div>
  );
}

export default EmptyPage;